import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function PageHeader() {
  const { t } = useLanguage();
  return (
    <div className="bg-primary">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        <nav className="flex items-center gap-2 text-sm text-white/80">
          <Link to="/" className="hover:text-white hover:underline transition-colors">
            {t("nav.home")}
          </Link>
          <i className="ri-arrow-right-s-line text-white/50" />
          <span className="text-white font-medium">{t("reviews.h1")}</span>
        </nav>
        <div className="flex items-center gap-2 text-sm font-medium text-white">
          <i className="ri-tools-line text-amber-300" />
          {t("reviews.h1")}
        </div>
      </div>
    </div>
  );
}